import { Component, OnInit } from '@angular/core';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { KioskStateService } from '../../services/kiosk-state.service';

@Component({
  selector: 'app-kiosk-add-child-button',
  templateUrl: './kiosk-add-child-button.component.html',
  styleUrls: ['./kiosk-add-child-button.component.css']
})
export class KioskAddChildButtonComponent implements OnInit {

  constructor (
    private kioskStateService: KioskStateService,
  ) {
  }

  ngOnInit() {
  }

  addChild() {
    this.kioskStateService.update(KioskStateEnum.AddChild);
  }

  finishRegistration() {
    this.kioskStateService.update(KioskStateEnum.ThankYou);
  }

}
